import LayoutAppTabs from '@/components/shared/LayoutAppTabs.vue'
import NotFoundView from '@/views/shared/NotFoundView.vue'

const routesShell = [
  {
    path: '/app-shell',
    name: 'AppShell',
    component: LayoutAppTabs,
    redirect: { name: 'Home' },
    meta: {
      public: false,
      reserveBottomBarNavSpace: true,
      pullToRefresh: true
    },
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/home/HomeView.vue'),
        meta: {
          title: 'Home',
          backgroundTheme: 'brand-reset'
        }
      },
      {
        path: '/insights',
        name: 'Insights',
        component: () => import('@/views/insights/InsightsView.vue'),
        meta: {
          title: 'Insights'
        }
      },
      {
        path: '/insights-v2/:propertyId',
        name: 'InsightsV2',
        component: () => import('@/views/insights/InsightsViewV2.vue'),
        meta: {
          title: 'Insights'
        }
      },
      {
        path: '/insights-v2',
        name: 'InsightsV2a',
        component: () => import('@/views/insights/InsightsViewV2.vue'),
        meta: {
          title: 'Insights'
        }
      },
      {
        path: '/automations',
        name: 'Automations',
        component: () => import('@/views/automations/AutomationsView.vue'),
        meta: {
          title: 'Automations'
        }
      },
      {
        path: '/settings',
        name: 'Settings',
        component: () => import('@/views/settings/SettingsView.vue'),
        meta: {
          title: 'Settings',
          backgroundTheme: 'brand-reset'
        }
      },
      {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFoundView,
        meta: {
          title: 'Oops! Not found'
        }
      }
    ]
  }
]

export default routesShell
